export default __webpack_public_path__ + "diamond.png";